import React from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import MicrophoneIcon from '@atlaskit/icon/core/microphone';

import messages from './messages';

export const VoiceMicrophoneButton = ({ onClick }: { onClick: () => void }) => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			shape="circle"
			isTooltipDisabled={false}
			icon={(iconProps) => <MicrophoneIcon {...iconProps} label={''} />}
			appearance="subtle"
			onClick={onClick}
			label={formatMessage(messages.voiceDictationButtonLabel)}
		/>
	);
};
